import { NextRouter } from 'next/router';
import getQueryString from './query';
import { IS_STAGING } from '../services/public-config';
import { DOMAINS } from '../constants/environment';
import { getNextPageUrl } from './helper';
import { USER_TYPES } from '../services/user';
/* eslint-disable import/prefer-default-export */
type OauthServices = 'google' | 'github';

type SERVICE_QUERY_PARAM_TYPE = {
  [key in OauthServices]: string;
};

const SERVICE_QUERY_PARAM: SERVICE_QUERY_PARAM_TYPE = {
  google: 'googleTree',
  github: 'githubTree',
};

export const getOauthUrl = (router: NextRouter, service: OauthServices): string => {
  // should include other marketing parameters
  const queryParams: string = getQueryString(router.query);

  let customParams = `service=${SERVICE_QUERY_PARAM[service]}`;

  const nextPageUrl = getNextPageUrl(router) || '/getting-started';
  if (nextPageUrl) customParams += `&next=${nextPageUrl}`;
  customParams += `&org_type=${USER_TYPES.FREEMIUM}`;

  customParams = queryParams ? `${queryParams}&${customParams}` : `?${customParams}`;

  return IS_STAGING ? `${DOMAINS.STAGING}${customParams}` : `${DOMAINS.PROD}${customParams}`;
};
